export const Topics = {
  GoTo: "go_to",
  SetChartSettings: "set_chart_settings",
  TakeChartScreenshot: "take_chart_screenshot",
  TakeMapScreenshot: "take_map_screenshot",
  WellList: "well_list",
  OpenChartScreenshot: "open_chart_screenshot",
  OpenMapScreenshot: "open_map_screenshot",
  LoadProject: "load_project",
  LoadSavedFilter: "load_saved_filter",
  SetFocus: "set_focus",
  //topics used to fetch data
  GetProjectIdAndSavedFilterInfo: "get_saved_filter",
  GetChartSettings: "chart_settings",
  GetMapLocationAndZoom: "get_map",
  GetChartScreenshotSettings: "get_chart_screenshot_settings",
  GetMapScreenshotSettings: "get_map_screenshot_settings"
} as const;

export type Topic = (typeof Topics)[keyof typeof Topics];

export type CommandId =
  | "load-filter"
  | "goto"
  | "map-screenshot"
  | "chart-screenshot"
  | "set-focus";
